export const STATUS_META = {
  open: { label: "Open", cls: "bg-sky-50 text-sky-700 border-sky-200", dot: "bg-sky-500" },
  under_assessment: { label: "Under Assessment", cls: "bg-amber-50 text-amber-800 border-amber-200", dot: "bg-amber-500" },
  approved: { label: "Approved", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", dot: "bg-emerald-500" },
  flown_out: { label: "Flown Out", cls: "bg-indigo-50 text-indigo-700 border-indigo-200", dot: "bg-indigo-500" },
  closed: { label: "Closed", cls: "bg-slate-100 text-slate-600 border-slate-200", dot: "bg-slate-400" },
};

export const STATUS_KEYS = Object.keys(STATUS_META);

export function StatusBadge({ status, testid }) {
  const m = STATUS_META[status] || STATUS_META.open;
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-xs font-medium ${m.cls}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${m.dot}`} />
      {m.label}
    </span>
  );
}
